import account from '../services/accountService';
import { ActionTypes } from '../constants';
import tokenStorage from "../services/tokenStorage";
import { logoutOn401 } from "./commonActions";

export const getProfile = () => (dispatch) => {
    account.getProfile(tokenStorage.getAuthToken()).then(
        response => {
            dispatch({type: ActionTypes.GET_ACCOUNT_PROFILE, data: response})
        }
    ).catch(logoutOn401(dispatch));
};

export const editProfile = (params) => (dispatch) => {
    account.editProfile(tokenStorage.getAuthToken(), params).then(
        response => {
            dispatch({type: ActionTypes.UPDATE_ACCOUNT_PROFILE_SUCCESS, data: response, payload: params})
        },
        error => {
            dispatch({
                type: ActionTypes.UPDATE_ACCOUNT_PROFILE_FAILURE,
                payload: params,
                code: (error.response && error.response.status) || null,
                message: `Error: ${error.response.data.error || ''}`
            });
        }
    );
};

export const editSecuritySettings = (params) => (dispatch) => {
    dispatch({type: ActionTypes.UPDATE_ACCOUNT_SECURITY_REQUEST, payload: params})
    account.editSecuritySettings(tokenStorage.getAuthToken(), params).then(
        response => {
            dispatch({type: ActionTypes.UPDATE_ACCOUNT_SECURITY_SUCCESS, data: response, payload: params})
        },
        error => {
            dispatch({
                type: ActionTypes.UPDATE_ACCOUNT_SECURITY_FAILURE,
                payload: params,
                code: (error.response && error.response.status) || null,
                message: `Error: ${error.response.data.error || ''}`
            });
        }
    );
};

export const requestPasswordResetLink = (email) => (dispatch) => {
    account.requestPasswordResetLink(email).then(
        response => {
            dispatch({type: ActionTypes.SEND_ACCOUNT_PASSWORD_RESET_LINK_SUCCESS, data: response, payload: { email }})
        },
        error => {
            dispatch({
                type: ActionTypes.SEND_ACCOUNT_PASSWORD_RESET_LINK_FAILURE,
                payload: { email },
                code: (error.response && error.response.error) || null,
                message: `Error: ${error.response.data.error_description || ''}`
            });
        }
    );
};

export const getSubscriptions = () => (dispatch) => {
    account.getSubscriptions(tokenStorage.getAuthToken()).then(
        response => {
            dispatch({type: ActionTypes.GET_ACCOUNT_SUBSCRIPTIONS, data: response})
        }
    ).catch(logoutOn401(dispatch));
};

const accountActions = {
    getProfile,
    editProfile,
    editSecuritySettings,
    requestPasswordResetLink,
    getSubscriptions
};

export default accountActions;
